import React, { ReactElement } from 'react'
import { useRouter } from 'next/router'
import { Flex } from '@mindfulchefuk/design-system'
import Loader from '@mindfulchefuk/components/Loader'
import { OnboardingChooseRecipesHeader } from '@mindfulchefuk/onboarding/components/OnboardingChooseRecipes/OnboardingChooseRecipesHeader/OnboardingChooseRecipesHeader'
import { useChooseRecipesContext } from '@mindfulchefuk/onboarding/context/ChooseRecipesContext/ChooseRecipesContext'
import { OnboardingChooseRecipesFilters } from '@mindfulchefuk/onboarding/components/OnboardingChooseRecipes/OnboardingChooseRecipesFilters/OnboardingChooseRecipesFilters'
import { OnboardingRecipes } from '@mindfulchefuk/features/Onboarding/components/OnboardingRecipes/OnboardingRecipes'
import { OnboardingRecipeModal } from '@mindfulchefuk/onboarding/components/OnboardingRecipeModal'

export const OnboardingChooseRecipesPage = (): ReactElement => {
  const router = useRouter()

  const {
    minimumRecipesForPortion,
    maximumRecipesForPortion,
    banner,
    isLoading,
    recipes,
    recipeIdsInBasket,
    handleAddRecipe,
    handleRemoveRecipe,
    totalNumberOfRecipes,
  } = useChooseRecipesContext()

  const queriedAvailabilityId = router?.query?.recipe

  if (isLoading) {
    return <Loader />
  }

  return (
    <>
      <Flex flexDirection="column">
        <OnboardingChooseRecipesHeader
          minimumRecipes={minimumRecipesForPortion}
          maximumRecipes={maximumRecipesForPortion}
          banner={banner}
        />
        <OnboardingChooseRecipesFilters />
        <OnboardingRecipes
          onAddRecipe={(recipe) =>
            handleAddRecipe({ recipe, clickOrigin: 'recipe' })
          }
          onRemoveRecipe={(recipe) =>
            handleRemoveRecipe({ recipe, clickOrigin: 'recipe' })
          }
          recipes={recipes}
          recipesIsPending={isLoading}
          maximumRecipes={maximumRecipesForPortion}
          totalNumberOfRecipes={totalNumberOfRecipes}
        />
      </Flex>
      {!!queriedAvailabilityId && !isLoading && (
        <OnboardingRecipeModal
          availabilityId={queriedAvailabilityId as string}
          isAdditionDisabled={
            recipeIdsInBasket.length === maximumRecipesForPortion
          }
          onIncrement={({ recipe }) =>
            handleAddRecipe({ recipe, clickOrigin: 'modal' })
          }
          onDecrement={({ recipe }) =>
            handleRemoveRecipe({ recipe, clickOrigin: 'modal' })
          }
        />
      )}
    </>
  )
}
